// extracted by mini-css-extract-plugin
export default {"wrapper":"NumberAndData_wrapper__Runox","number":"NumberAndData_number__TeLjt","label":"NumberAndData_label__HnwNs"};